import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useResolvedPath, useMatch } from 'react-router-dom';

import { MAINTENANCES_QUERY } from '../queries';
import { compareAsc, isPast, isFuture, format } from 'date-fns';

import cogs from '../assets/cogs.svg';

export default function MaintenancePage() {
  const { data } = useQuery(MAINTENANCES_QUERY, {
    pollInterval: 60000,
    fetchPolicy: 'network-only',
  });
  const maintenances = data?.maintenances;

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const num = Number(dateStr);
    return isNaN(num) ? new Date(dateStr) : new Date(num);
  };

  const currentMaintenance = useMemo(() => {
    if (maintenances) {
      const currentMaintenances = maintenances.filter(
        ({ startDate, endDate }) => {
          const start = parseDate(startDate);
          const end = parseDate(endDate);
          return isPast(start) && (endDate == null || isFuture(end));
        }
      );

      if (currentMaintenances?.length > 0) {
        const sortedMaintenances = currentMaintenances.sort((a, b) =>
          compareAsc(parseDate(a.startDate), parseDate(b.startDate))
        );
        return sortedMaintenances?.[0];
      }
    }
  }, [maintenances]);

  const adminResolvedPath = useResolvedPath('admin');
  const adminMatch = useMatch({
    path: adminResolvedPath.pathname,
    end: false,
  });

  const signinResolvedPath = useResolvedPath('signin');
  const signinMatch = useMatch({
    path: signinResolvedPath.pathname,
    end: false,
  });

  return (
    <>
      {currentMaintenance && !adminMatch && !signinMatch && (
        <div className="fixed max-w-full max-h-full inset-0 z-40 flex justify-center items-center bg-white">
          <div className="flex flex-row space-x-10 align-center">
            <div className="w-96">
              <h2>Scheduled Maintenance</h2>
              <p className="mb-8">
                We're updating our data set so we can provide you the best
                possible audiences. While we do so, the platform is unavailable.
              </p>
              {currentMaintenance?.endDate && (
                <p>
                  The platform will be available again at{' '}
                  {format(parseDate(currentMaintenance.endDate), 'PPP ppp')}
                </p>
              )}
              {!currentMaintenance?.endDate && (
                <p>Please check back in a few hours.</p>
              )}
            </div>

            <img src={cogs} alt="cogs" />
          </div>
        </div>
      )}
    </>
  );
}
